import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatMoney } from '../../../../util/numberUtils';

/**
 * 🧬 Molécula: OrderNoteSummaryMC
 * Renderiza el resumen de totales de la orden.
 */
const OrderNoteSummaryMC = React.memo(({ order, currency, currencySymbol }) => {
  const { t } = useTranslation('InboxMC');
  return (
    <div className="tw-mt-2">
      <div className="tw-flex tw-mt-2">
        <label className="tw-text-xs tw-font-bold">{t('orderNote.summary')}</label>
      </div>
      <div className="tw-flex tw-justify-between">
        <span>{t('orderNote.subtotal')}</span>
        <span>
          {currencySymbol}
          {formatMoney(order.subtotal)} {currency}
        </span>
      </div>
      {Number(order.total_discount) > 0 && (
        <>
          <div className="tw-flex tw-justify-between">
            <span>{t('orderNote.discount')}</span>
            <span>
              -{currencySymbol}
              {formatMoney(order.total_discount)} {currency}
            </span>
          </div>
          <div className="tw-flex tw-justify-between">
            <span>{t('orderNote.subtotal_with_discount')}</span>
            <span>
              {currencySymbol}
              {formatMoney(order.subtotal_with_discount)} {currency}
            </span>
          </div>
        </>
      )}
      <div className="tw-flex tw-justify-between">
        <span>{t('orderNote.tax')}</span>
        <span>
          {currencySymbol}
          {formatMoney(order.tax)} {currency}
        </span>
      </div>
      <div className="tw-flex tw-justify-between">
        <span>{t('orderNote.shipping_value')}</span>
        <span>
          {currencySymbol}
          {formatMoney(order.shipping_value)} {currency}
        </span>
      </div>
      <div className="tw-flex tw-justify-between tw-mt-2">
        <label className="tw-font-bold">{t('orderNote.grand_total')}</label>
        <span className="tw-font-bold">
          {currencySymbol}
          {formatMoney(order.total)} {currency}
        </span>
      </div>
    </div>
  );
});

OrderNoteSummaryMC.displayName = 'OrderNoteSummaryMC';
export default OrderNoteSummaryMC;
